import videojs from 'video.js';
import { getSlideHtml } from './get-slide-html';
import './swiper-bundle.min.css';
import Swiper from './swiper-bundle.min';
import { throttle } from '../../js/helpers/throttle-debounce';
import { getCurrencyHtml } from "./get-currency-html";

const Component = videojs.getComponent('Component');

const defaultOptions = {};

export default class ListProducts extends Component {
  constructor(player, options) {
    super(player, options);
    this.player = player;
    this.options = videojs.mergeOptions(defaultOptions, options);
    this.setProductsViewMode('list', this.options.products);
    this.scrollTop = 0;
    this.setListeners();
  }

  resetHeight() {
    this.el().style.height = '';
  }

  setHeight(height) {
    this.el().style.height = height;
  }

  setListeners() {
    this.el()
      .querySelector('.vjs-list-products-header__button_close')
      .addEventListener('click', () => {
        this.toggleVisibility();
      });

    this.el()
      .querySelector('.vjs-list-products-overlay')
      .addEventListener('click', () => {
        this.toggleVisibility();
      });

    this.el()
      .querySelector('.vjs-list-products-header__button_back')
      .addEventListener('click', () => {
        this.setProductsViewMode('list', this.options.products);
      });

    this.el()
      .querySelector('.vjs-list-products-catalogue')
      .addEventListener('click', (event) => {
        if (event.target.classList.contains('vjs-stream-shopping-slider__buy')) return;
        let slideEl = event.target;
        while(!slideEl.classList.contains('vjs-stream-shopping-slider__slide')) {
          if (slideEl === event.currentTarget) return;
          slideEl = slideEl.parentElement;
        }
        if (slideEl) {
          const productId = slideEl.dataset.productId;
          this.scrollTop = this.el().querySelector('.vjs-list-products-content').scrollTop;
          this.setProductsViewMode('detail', this.options.products[productId]);
        }
      });

    this.el()
      .querySelector('.vjs-list-products-content')
      .addEventListener('scroll', throttle(100, false, (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        const diff = scrollHeight - (scrollTop + clientHeight);
        const maxBlurHeight = 48;
        this.el()
          .querySelector('.vjs-list-products-catalogue')
          .style
          .setProperty('--blur-height', `${ Math.min(diff, maxBlurHeight) }px`);
      }));

    this.player.one('playing', () => {
      const handleResize = throttle(100, false, () => {
        const { viewMode } = this.player.el_.dataset;
        if (viewMode === 'desktop') {
          // this.el().classList.remove('vjs-list-products_hide');
          this.show();
          this.player.getChild('ButtonToggleListProducts').hide();
        } else if (viewMode === 'tablet') {
          // this.el().classList.remove('vjs-list-products_hide');
          this.show();
          this.player.getChild('ButtonToggleListProducts').hide();
        } else if (viewMode === 'mobile') {
          // this.el().classList.add('vjs-list-products_hide');
          this.hide();
          this.player.getChild('ButtonToggleListProducts').show();
        }
      });
      if (this.player.el_.dataset.viewMode === 'desktop') {
        // this.el().classList.remove('vjs-list-products_hide');
        this.show();
        this.player.getChild('ButtonToggleListProducts').hide();
      }
      this.player.on('playerresize', handleResize);
      handleResize();
    });
  }

  setProductsViewMode(mode, product) {
    const thisEl = this.el();
    const titleEl = thisEl.querySelector('.vjs-list-products-header__title');
    if (mode === 'list') {
      titleEl.innerText = `Товары: ${this.options.products.length}`;
      this.renderListProducts(product);
      thisEl.classList.add('vjs-list-products_show-list');
      thisEl.classList.remove('vjs-list-products_show-detail');
      thisEl.querySelector('.vjs-list-products-content').scrollTop = this.scrollTop;
    } else if (mode === 'detail') {
      titleEl.innerText = 'Просмотр товара';
      this.renderProductDetails(product);
      thisEl.classList.remove('vjs-list-products_show-list');
      thisEl.classList.add('vjs-list-products_show-detail');
      thisEl.querySelector('.vjs-list-products-content').scrollTop = 0;
      new Swiper(
        this.el().querySelector('.vjs-list-products-detail__slider'),
        {
          pagination: {
            el: '.vjs-list-products-detail__slider .swiper-pagination',
          },
          navigation: {
            nextEl: '.vjs-list-products-detail__slider .swiper-button-next',
            prevEl: '.vjs-list-products-detail__slider .swiper-button-prev',
          },
        }
      );
    }
  }

  renderListProducts(products) {
    this.el()
      .querySelector('.vjs-list-products-catalogue')
      .innerHTML = products.reduce(
        (html, product, index) => html + getSlideHtml(product, index),
        ''
      );
  }

  renderProductDetails(product) {
    const container = this.el().querySelector('.vjs-list-products-detail');
    const currencyHtml = getCurrencyHtml(product.currency);
    container.innerHTML = `
      <div class="vjs-list-products-detail__slider swiper">
        <div class="swiper-wrapper">
          ${ getSlidesHtml(product.img) }
        </div>

        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>

        <!-- If we need pagination -->
        <div class="swiper-pagination"></div>
      </div>
      <div class="vjs-list-products-detail__title">${ product.title }</div>
      <div class="vjs-list-products-detail__description">${ product.description }</div>
      <div class="vjs-list-products-detail__footer">
        <div class="vjs-list-products-detail__price">
          <div class="vjs-list-products-detail__current-price">${ product.price } ${ currencyHtml }</div>
          <div class="vjs-list-products-detail__old-price">${ product.oldPrice ? product.oldPrice + ' ' + currencyHtml : '' }</div>
        </div>
        <a href="${ product.url || '' }" class="vjs-list-products-detail__buy" target="_blank" rel="noopener noreferrer">К товару</a>
      </div>
    `;
    function getSlidesHtml(img) {
      let _img;
      if (typeof img === 'string') {
        _img = [img];
      } else if (Array.isArray(img)) {
        _img = img;
      } else {
        return '';
      }
      return _img.reduce((html, url) => html + `<div class="swiper-slide"><img class="swiper-slide__img" src="${ url }" /></div>`, '');
    }
  }

  toggleVisibility() {
    // this.el().classList.toggle('vjs-list-products_hide');
    this.hasClass('vjs-hidden') ? this.show() : this.hide();
  }

  checkVisibility() {
    // this.el().classList.contains('vjs-list-products_hide');
    return !this.hasClass('vjs-hidden');
  }

  createEl() {
    const el = videojs.createEl('div', {
      className: 'vjs-list-products vjs-hidden',
    });
    el.innerHTML = this.getInnerHtml();
    return el;
  }

  getInnerHtml() {
    return `
      <div class="vjs-list-products-overlay"></div>
      <div class="vjs-list-products-wrapper">
        <div class="vjs-list-products-header">
          <button class="vjs-list-products-header__button vjs-list-products-header__button_back vjs-list-products-header__button_hide">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
              <path d="M8.03036 15.2803C8.17097 15.1396 8.24995 14.9489 8.24995 14.75C8.24995 14.5511 8.17097 14.3604 8.03036 14.2197L2.56064 8.75H17.25C17.4489 8.75 17.6397 8.67099 17.7803 8.53033C17.921 8.38968 18 8.19891 18 8C18 7.80109 17.921 7.61032 17.7803 7.46967C17.6397 7.32902 17.4489 7.25 17.25 7.25H2.56064L8.03036 1.78032C8.17101 1.63966 8.25003 1.44889 8.25002 1.24997C8.25001 1.05105 8.17098 0.860286 8.03032 0.719637C7.88966 0.578987 7.69888 0.499976 7.49997 0.499985C7.30105 0.499993 7.11028 0.579021 6.96964 0.719683L0.219635 7.46968C0.217186 7.47211 0.215172 7.47481 0.212769 7.47728C0.197956 7.49248 0.183586 7.50809 0.170105 7.52448C0.162575 7.53363 0.156006 7.54334 0.148979 7.55277C0.141385 7.56293 0.133484 7.57291 0.126385 7.58348C0.119084 7.59438 0.112745 7.60573 0.106061 7.61695C0.100224 7.62674 0.0940678 7.63631 0.0886434 7.64643C0.0826237 7.65769 0.0774964 7.66931 0.072072 7.6808C0.0670095 7.69151 0.0616808 7.70204 0.0571264 7.71298C0.0525486 7.72406 0.048841 7.73541 0.0448126 7.74668C0.0405554 7.75849 0.0360235 7.77021 0.0323607 7.78229C0.0289735 7.7935 0.0264786 7.8049 0.0236174 7.81626C0.0205049 7.82861 0.0170258 7.84088 0.0145311 7.85347C0.0119446 7.86657 0.0103884 7.87975 0.00851154 7.89289C0.00693186 7.90397 0.00482635 7.91481 0.00373042 7.92598C0.0013051 7.95061 0 7.97528 0 8C0 8.02472 0.0013051 8.0494 0.00373042 8.07402C0.00482917 8.08519 0.00693467 8.09604 0.00851154 8.10712C0.0103865 8.12025 0.0119446 8.13344 0.0145311 8.14653C0.0170258 8.15912 0.0205049 8.17139 0.0236174 8.18375C0.0264786 8.1951 0.0289735 8.2065 0.0323607 8.21771C0.0360235 8.2298 0.0405554 8.24152 0.0448126 8.25333C0.0488438 8.26459 0.0525486 8.27594 0.0571264 8.28702C0.0616808 8.29796 0.0670133 8.30849 0.072072 8.3192C0.0774964 8.33069 0.0826237 8.34232 0.0886434 8.35358C0.0940678 8.3637 0.100224 8.37327 0.106061 8.38306C0.112745 8.39427 0.119084 8.40563 0.126385 8.41652C0.133481 8.42709 0.141378 8.43707 0.148979 8.44724C0.15601 8.45667 0.162573 8.46637 0.170105 8.47553C0.183815 8.49223 0.19844 8.50812 0.213546 8.52359C0.215675 8.52575 0.217461 8.52817 0.219635 8.53032L6.96964 15.2803C7.03928 15.35 7.12197 15.4052 7.21297 15.4429C7.30397 15.4806 7.4015 15.5 7.5 15.5C7.5985 15.5 7.69603 15.4806 7.78703 15.4429C7.87803 15.4052 7.96072 15.35 8.03036 15.2803Z" fill="currentColor"/>
            </svg>
          </button>
          <div class="vjs-list-products-header__title"></div>
          <button class="vjs-list-products-header__button vjs-list-products-header__button_close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M9.06059 8L15.2803 1.78031C15.4208 1.63963 15.4997 1.44892 15.4996 1.25009C15.4995 1.05127 15.4205 0.860601 15.2799 0.720009C15.1393 0.579417 14.9487 0.500406 14.7499 0.500343C14.551 0.500281 14.3603 0.579173 14.2196 0.719677L7.99995 6.93936L1.78027 0.719677C1.63959 0.579173 1.44888 0.500281 1.25005 0.500343C1.05122 0.500406 0.860556 0.579417 0.719964 0.720009C0.579373 0.860601 0.500361 1.05127 0.500299 1.25009C0.500237 1.44892 0.579129 1.63963 0.719632 1.78031L6.93931 8L0.719632 14.2197C0.649918 14.2893 0.594606 14.372 0.556858 14.463C0.51911 14.554 0.499665 14.6516 0.499634 14.7501C0.499603 14.8486 0.518987 14.9462 0.556678 15.0372C0.594369 15.1283 0.649629 15.211 0.719299 15.2806C0.78897 15.3503 0.871686 15.4056 0.962721 15.4433C1.05376 15.481 1.15133 15.5003 1.24985 15.5003C1.34838 15.5003 1.44594 15.4808 1.53695 15.4431C1.62796 15.4053 1.71064 15.35 1.78027 15.2803L7.99995 9.06063L14.2196 15.2803C14.3603 15.4208 14.551 15.4997 14.7499 15.4996C14.9487 15.4996 15.1393 15.4206 15.2799 15.28C15.4205 15.1394 15.4995 14.9487 15.4996 14.7499C15.4997 14.5511 15.4208 14.3604 15.2803 14.2197L9.06059 8Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <div class="vjs-list-products-content vjs-list-products-scrollbar">
          <div class="vjs-list-products-catalogue"></div>
          <div class="vjs-list-products-detail"></div>
        </div>
      </div>
    `;
  }
}

Component.registerComponent('ListProducts', ListProducts);
